import React from 'react';
import { Box, Typography, Chip, Paper } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

/**
 * Shared header for role-specific pages — says whose view this is in one line.
 * UI review 2026-09-21 §6: three chips repeating "Administrator" plus "Role preview" read as
 * internal jargon; now one line: "Viewing as <role>" (+ the member when View-as picked one).
 */
function RoleHero({ icon: Icon = PersonOutlineIcon, title, persona, personaUser, color = 'primary.main', children }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 1.5, sm: 2.5 },
        mb: 3,
        borderRadius: 2,
        borderLeft: 6,
        borderLeftColor: color,
        display: 'flex',
        alignItems: 'flex-start',
        gap: { xs: 1.25, sm: 2 },
      }}
    >
      <Box sx={{ color, display: { xs: 'none', sm: 'flex' }, alignItems: 'center', mt: 0.5 }}>
        <Icon sx={{ fontSize: 32 }} />
      </Box>
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography variant="h5" fontWeight={700} sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' }, lineHeight: 1.2, textWrap: 'balance' }}>
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mt: 0.75 }}>
          <Typography variant="body2" color="text.secondary">
            Viewing as <strong>{personaUser ? `${personaUser.name} — ${personaUser.title}` : persona.label}</strong>
          </Typography>
          {personaUser && <Chip label={persona.label} size="small" variant="outlined" />}
        </Box>
        {persona.description && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
            {persona.description}
          </Typography>
        )}
        {children}
      </Box>
    </Paper>
  );
}

export default RoleHero;
